import React from 'react';
import styled from 'styled-components';
import {elevation} from '@atlaskit/theme';

import ErrorIcon from '@atlaskit/icon/glyph/error';
import dateformat from 'dateformat';
import {colors} from '@atlaskit/theme';

const Container = styled.div`
  ${elevation['e100']}
  background-color: white;
  border-radius: 3px;
  padding: 16px 24px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`;

const TitleWrapper = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #253858;
  flex: 1;
  margin-left: 16px;
`;

const DateWrapper = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: rgba(37, 56, 88, 0.7);
`;

export const EmptyContainer = ({msg}) => (
  <Container>
    <TitleWrapper>
      {msg}
    </TitleWrapper>
  </Container>
)

export default ({code, details, createdAt}) => {
  return (
    <Container>
      <ErrorIcon primaryColor={colors.R500}/>
      <TitleWrapper>
        {code}: {details}
      </TitleWrapper>
      <DateWrapper>{dateformat(createdAt, 'dd.mm.yyyy HH:MM')}</DateWrapper>
    </Container>
  )
}
